/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TopicRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return hash({
      allGoals: this.store.findAll('goals/goal', {}),
      allSubjects: this.store.findAll('goals/subject', {}),
      allCategories: this.store.findAll('goals/category', {}),
      allSubcategories: this.store.findAll('goals/subcategory', {}),
      goal: this.store.findRecord('goals/goal', params.goal_id),
    });
  }

  async afterModel(model) {
    super.afterModel(...arguments);
    // findRecord gives a plain Promise. Wait for the records, because the
    // template reads their labels. A goal can have no category.
    let categoryId = model.goal.get('category_id');
    [model.category, model.subject] = await Promise.all([
      categoryId ? this.store.findRecord('goals/category', categoryId) : null,
      this.store.findRecord('goals/subject', model.goal.get('subject_id')),
    ]);
  }
}
